<div class="cm-section-title">Other outputs</div>
@if ($material(); as material) {
    @if (material.latestCyclesRevision) {
        @if ($can().read.material(material, "outputs")) {
            <cm-dropdown-button
                [class.cm-unavailable]="$customPbrExports().length === 0"
                [disabled]="$customPbrExports().length === 0 && !$can().update.material(material, 'outputs')"
            >
                <ng-container cm-left-icon>
                    <i class="fa-solid fa-box-archive"></i>
                </ng-container>
                <ng-container cm-text>PBR exports ({{ $customPbrExports().length }})</ng-container>
                <ng-container cm-dropdown-content>
                    <div class="cm-options-list">
                        @if ($customPbrExportsButtonStates().length > 0) {
                            <div class="cm-export-section-headline">Custom exports</div>
                            @for (customPbrExportsButtonState of $customPbrExportsButtonStates(); track $index) {
                                @if ($can().update.material(material, "outputs") || customPbrExportsButtonState.state === "complete") {
                                    @if (customPbrExportsButtonState.exportSummary && customPbrExportsButtonState.sourceInfo) {
                                        <cm-dropdown-inline-button>
                                            <ng-container cm-inline-button>
                                                <cm-material-output-button [props]="customPbrExportsButtonState"></cm-material-output-button>
                                            </ng-container>
                                            <ng-container cm-dropdown-content>
                                                <cm-material-output-pbr-export-detail
                                                    [exportSummary]="customPbrExportsButtonState.exportSummary"
                                                    [sourceInfo]="customPbrExportsButtonState.sourceInfo"
                                                ></cm-material-output-pbr-export-detail>
                                            </ng-container>
                                        </cm-dropdown-inline-button>
                                    } @else {
                                        <cm-material-output-button [props]="customPbrExportsButtonState"></cm-material-output-button>
                                    }
                                }
                            }
                        }
                        @if ($can().update.material(material, "outputs")) {
                            <cm-dropdown-button>
                                <ng-container cm-left-icon>
                                    <i class="fa-solid fa-sliders-h"></i>
                                </ng-container>
                                <ng-container cm-text> Custom exports ({{ $customPbrExports().length }})</ng-container>
                                <ng-container cm-dropdown-content>
                                    <cm-material-output-custom-pbr-export-form [onSubmit]="generateCustomPbrExport" [existingSettings]="$customPbrExportSettings()"></cm-material-output-custom-pbr-export-form>
                                </ng-container>
                            </cm-dropdown-button>
                        }
                    </div>
                </ng-container>
            </cm-dropdown-button>

            <!-- Only owners (can generate outputs) may start/manage a pCon export; non-owners of a
            publicly downloadable material see it only to download an already-completed export. -->
            @if ($canGenerateOutputs() || $pconExportButtonState().state === "complete") {
                <cm-material-output-button [props]="$pconExportButtonState()"></cm-material-output-button>
            }

            @if ($can().read.menu("generateFabricOverview")) {
                <cm-material-output-button [props]="$fabricOverviewButtonState()"></cm-material-output-button>
            }
        } @else {
            <cm-hint>
                <ng-container cm-text> Outputs for materials outside your organizations are not visible to you.</ng-container>
            </cm-hint>
        }
    } @else {
        <cm-hint>
            <ng-container cm-text>
                @if (material.textureGroup) {
                    Please create a new material and <b>save it</b>. The material output options will only appear then.
                } @else {
                    Please scan a new fabric to get started.
                }
            </ng-container>
        </cm-hint>
    }
} @else {
    <cm-placeholder [dark]="true"></cm-placeholder>
    <cm-placeholder [dark]="true"></cm-placeholder>
    <cm-placeholder [dark]="true"></cm-placeholder>
    <cm-placeholder [dark]="true"></cm-placeholder>
}
